import React from 'react';
import './ProjectIcon.module.scss';

interface ProjectIconProps {
    iconData: string | null;
    size?: 'sm' | 'md' | 'lg';
    alt?: string;
    className?: string;
}

const ProjectIcon: React.FC<ProjectIconProps> = ({
  iconData,
  size = 'md',
  alt = 'Project Icon',
  className = ''
}) => {
  // Size mapping
  const sizeMap = {
    sm: 24,
    md: 32,
    lg: 48
  };

  const pixelSize = sizeMap[size];

  if (!iconData) {
    return (
      <div
        className={`project-icon-placeholder ${className}`}
        style={{
          width: `${pixelSize}px`,
          height: `${pixelSize}px`,
          borderRadius: '4px',
          backgroundColor: '#f0f0f0',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          fontSize: `${pixelSize / 2}px`,
          color: '#aaa'
        }}
      >
        <span>?</span>
      </div>
    );
  }

  // Make sure the base64 string has the proper data URL prefix
  const iconSrc = iconData.startsWith('data:')
    ? iconData
    : `data:image/png;base64,${iconData}`;

  return (
    <div
      style={{
        position: 'relative',
        width: `${pixelSize}px`,
        height: `${pixelSize}px`
      }}
      className={`project-icon-container ${className}`}
    >
      <img
        src={iconSrc}
        alt={alt}
        className="project-icon"
        style={{
          width: `${pixelSize}px`,
          height: `${pixelSize}px`,
          borderRadius: '4px',
          objectFit: 'cover',
          boxShadow: '0px 0px 3px rgba(0, 0, 0, 0.2)'
        }}
        onError={(e) => {
          e.currentTarget.style.display = 'none';
          const parent = e.currentTarget.parentElement!;
          parent.innerHTML = `<div style="width:${pixelSize}px;height:${pixelSize}px;border-radius:4px;background:#f0f0f0;display:flex;justify-content:center;align-items:center;color:#d00;">!</div>`;
        }}
      />
    </div>
  );
};

export default ProjectIcon;
